export var historyEntryDecorator = function (entry, rootPath) {
    return {
        search: stringify(entry.query || {}),
        pathname: "".concat(rootPath, "/search").concat(entry.pathname),
        state: entry.state,
    };
};
function stringifyParameter(key, value) {
    if (value === undefined) {
        return '';
    }
    else if (value === null) {
        return encodeURIComponent(key);
    }
    else {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }
}
function stringify(query) {
    if (!query) {
        return '';
    }
    return Object.keys(query)
        .sort()
        .map(function (key) { return stringifyParameter(key, query[key]); })
        .filter(function (parameter) { return parameter.length > 0; })
        .join('&');
}
//# sourceMappingURL=historyUtils.js.map